import React from 'react'
import MaterialTable from 'material-table';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Service from '../../config/networkutils';
import { withStyles } from '@material-ui/core/styles';
import PRPTemplate from '../PRPTemplate/PRPTemplate';
import { sales_status_api, gate_stage_api, account_name_api } from '../../config/apiList';
import { withSnackbar } from 'notistack';
import { getCookie } from '../../utils/CookieHelper';
import { RotateCircleLoading } from 'react-loadingg';
import { getLookupObj } from '../../utils/reuseFunctions';
import PropTypes from 'prop-types';
import { Box, Paper } from "@material-ui/core";
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { getDataIsdeletedFalse, getPrimaryColor } from '../Helper/CommonThings';


const user = JSON.parse(getCookie("ptd_ts_user"))
const token = getCookie("ptd_ts_token");

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = (theme) => ({
    appBar: {
        position: 'fixed',
        top: 0,
    },
    formContainer: {
        marginTop: '64px'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    }
});
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    // let _componentStatus.current = useRef(true);
    // useEffect(() => {
    //     let componentMounted = true;
    //       const fetchData = async () => {
    //        //you async action is here
    //         if(componentMounted) {
    //           setData(response?.data);
    //         }
    //       };
    //       fetchData();
    //       return () => {
    //        componentMounted = false;
    //       }
    //     }, []);
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={'span'} variant={'body2'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class UnsecuredProjects extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            columns: [],
            data: [],
            modelOpen: false,
            selectedOpportunity: {},
            selectedFilter: [],
            reportModal: false,
            view_type: 'Live',
            gateLevelObj: {},
            salesStatusObj: {},
            completedOpportunities: [],
            isLoading: true
        }
    }
    getSalesStatusList() {
        return new Promise((resolve, reject) => {
            Service.get(sales_status_api, {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                resolve(resData)
            }).catch(error => reject(error))
        })
    }
    getGateLevelList() {
        return new Promise((resolve, reject) => {
            Service.get(gate_stage_api, {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                resolve(resData)
            }).catch(error => reject(error))
        })
    }


    handleTabChange(event, newValue) {

        if (newValue === 0) {
            this.setState({ tabValue: newValue })
        }
        if (newValue === 1) {
            this.setState({ tabValue: newValue })
        }
    };

    getAccountNameList() {
        return new Promise((resolve, reject) => {
            Service.get(account_name_api, {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                let resData = getDataIsdeletedFalse(res.data)
                resolve(resData)
            }).catch(error => reject(error))
        })
    }

    getAllList() {
        return new Promise((resolve, reject) => {
            Service.get('/api/crm/crmlinkedcolumns_api/', {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                resolve(res.data)
            }).catch(error => reject(error))
        })
    }

    getFormattedLookupObj(arr) {
        let obj = {}
        arr.forEach(ele => {
            obj = { ...obj, ...{ [ele.id]: ele.name } }
        })
        return obj
    }

    getCounty() {
        return new Promise((resolve, reject) => {
            Service.get('/api/county/get_business_unit_county/', {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                let resData = getDataIsdeletedFalse(res.data)
                resolve(resData)
            }).catch(error => reject(error))
        })
    }

    getData() {
        Promise.all([
            this.getGateLevelList(),
            this.getSalesStatusList(),
            this.getAccountNameList(),
            this.getAllList(),
            this.getCounty()
        ]).then(
            res => {
                let newArr = []
                for (let i = 0; i < 2; i++) {
                    let formattedObj = getLookupObj(res[i]);
                    newArr.push(formattedObj)
                }
                this.setState({
                    gateLevelObj: newArr[0],
                    salesStatusObj: newArr[1],
                    accountNameObj: this.getFormattedLookupObj(res[2]),
                    subSectorList: this.getFormattedLookupObj(res[3].subsector),
                    marketSubVerticalList: this.getFormattedLookupObj(res[3].marketsubvertical),
                    ownerDeliverUnitList: this.getFormattedLookupObj(res[3].ownerdelivery),
                    ownerRegionList: this.getFormattedLookupObj(res[3].ownerregion),
                    opportunityTypeList: this.getFormattedLookupObj(res[3].opportunitytype),
                    salesStatusList: this.getFormattedLookupObj(res[3].salesstatus),
                    countyList: this.getFormattedLookupObj(res[4])
                })


                this.setColumn()
            })
            .catch(e => {
                this.setState({ isLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }
    componentDidMount() {
        if (this.props) {
            this.setState({
                tabValue: this.props.tabValue
            })
        }
        // this.setState({ isLoading: true })
        this.getData()
    }

    setColumn() {
        let columns = [
            // {
            //     title: 'Favourite', field: 'is_favourite',
            //     render: rowData => <div>
            //         {
            //             <IconButton onClick={(event) => event.preventDefault()}>
            //                {rowData.is_favourite ? <StarIcon color="secondary" /> : <StarBorderIcon color="secondary" />}
            //             </IconButton> 
            //         }
            //     </div>
            // },
            { title: 'Opportunity Id', field: 'opportunity_id', },
            { title: 'Opportunity Name', field: 'name', },
            { title: 'Project Code', field: 'project_code', },
            { title: 'Gate Level', field: 'gate_level_acheived', lookup: this.state.gateLevelObj },
            {
                title: "Opportunity Status",
                field: "archive_reason",
                lookup: {
                    0: "live",
                    1: "Lost",
                    2: "Withdrawn",
                    3: "Client cancelled",
                    4: "Complete",
                },
            },
            {
                title: 'Project Color', field: 'color_code', width: 100, render: (rowData) => <div style={{
                    background: rowData.color_code ? rowData.color_code : '', width: '3rem', height: '1rem'
                }}></div>,
            },
            { title: 'Location', field: 'location', },
            { title: 'Contract Start Date', field: 'contractor_start_date', type: 'date', },
            { title: 'Contract End Date', field: 'contractor_end_date', type: 'date', },
            { title: 'Distribution Type', field: 'sales_status', lookup: this.state.salesStatusObj },
            { title: 'Account Name', field: 'account_name', lookup: this.state.accountNameObj },
            { title: 'Bb Project Value', field: 'bb_project_value' },
            { title: 'Bid Resource', field: 'bid_resource' },
            { title: 'Contract Award Value', field: 'contract_award_value' },
            { title: 'Contract No', field: 'contract_no' },
            { title: 'Date Created', field: 'date_created', render: rowData => rowData.date_created ? new Date(rowData.date_created).toLocaleDateString() : '' },
            { title: 'Project Address', field: 'description' },
            { title: 'Expected Award Date', field: 'expected_award_date', render: rowData => rowData.expected_award_date ? new Date(rowData.expected_award_date).toLocaleDateString() : '' },
            { title: 'Id', field: 'id' },
            { title: 'Itt Due Date', field: 'itt_due_date', render: rowData => rowData.itt_due_date ? new Date(rowData.itt_due_date).toLocaleDateString() : '' },
            { title: 'Itt Start Date', field: 'itt_start_date', render: rowData => rowData.itt_start_date ? new Date(rowData.itt_start_date).toLocaleDateString() : '' },
            { title: 'Location', field: 'location' },
            { title: 'Market Sub Vertical', field: 'market_sub_vertical', lookup: this.state.marketSubVerticalList },
            { title: 'Owner Delivery', field: 'owner_delivery', lookup: this.state.ownerDeliverUnitList },
            { title: 'Owner Region Sector', field: 'owner_region_sector', lookup: this.state.ownerRegionList },
            { title: 'Sales Lead', field: 'sales_lead', lookup: this.state.salesLeadList },
            { title: 'Scope Of Work', field: 'scope_of_work' },
            { title: 'Start On Site Date', field: 'start_on_site_date', render: rowData => rowData.start_on_site_date ? new Date(rowData.start_on_site_date).toLocaleDateString() : '' },
            { title: 'Sub Sector', field: 'subsector', lookup: this.state.subSectorList },
            { title: 'County', field: 'county', lookup: this.state.countyList },
            { title: 'Submission Margin', field: 'submission_margin' },
            { title: 'Tender Submit Date', field: 'tender_submit_date', render: rowData => rowData.tender_submit_date ? new Date(rowData.tender_submit_date).toLocaleDateString() : '' },
            { title: 'Days Shift', field: 'daysShift' },
            { title: 'Itt Days Diff', field: 'ittDaysDiff' },
            { title: 'Emp Update Count', field: 'empUpdateCount' },
            { title: 'Refresh Crm', field: 'refreshCRM' },
            { title: 'Color Code', field: 'color_code' },
            { title: 'W3w', field: 'w3w' },
            { title: 'Eci Start Date', field: 'eci_start_date', render: rowData => rowData.eci_start_date ? new Date(rowData.eci_start_date).toLocaleDateString() : '' },
            { title: 'Eci End Date', field: 'eci_end_date', render: rowData => rowData.eci_end_date ? new Date(rowData.eci_end_date).toLocaleDateString() : '' },
            { title: 'Stage1 Start Date', field: 'stage1_start_date', render: rowData => rowData.stage1_start_date ? new Date(rowData.stage1_start_date).toLocaleDateString() : '' },
            { title: 'Stage1 End Date', field: 'stage1_end_date', render: rowData => rowData.stage1_end_date ? new Date(rowData.stage1_end_date).toLocaleDateString() : '' },
            { title: 'Stage2 Start Date', field: 'stage2_start_date', render: rowData => rowData.stage2_start_date ? new Date(rowData.stage2_start_date).toLocaleDateString() : '' },
            { title: 'Stage2 End Date', field: 'stage2_end_date', render: rowData => rowData.stage2_end_date ? new Date(rowData.stage2_end_date).toLocaleDateString() : '' },
            { title: 'Tender Start Date', field: 'tender_start_date', render: rowData => rowData.tender_start_date ? new Date(rowData.tender_start_date).toLocaleDateString() : '' },
            { title: 'Tender End Date', field: 'tender_end_date', render: rowData => rowData.tender_end_date ? new Date(rowData.tender_end_date).toLocaleDateString() : '' },
            { title: 'Design Start Date', field: 'design_start_date', render: rowData => rowData.design_start_date ? new Date(rowData.design_start_date).toLocaleDateString() : '' },
            { title: 'Design End Date', field: 'design_end_date', render: rowData => rowData.design_end_date ? new Date(rowData.design_end_date).toLocaleDateString() : '' },
            { title: 'Construction Start Date', field: 'construction_start_date', render: rowData => rowData.construction_start_date ? new Date(rowData.construction_start_date).toLocaleDateString() : '' },
            { title: 'Construction End Date', field: 'construction_end_date', render: rowData => rowData.construction_end_date ? new Date(rowData.construction_end_date).toLocaleDateString() : '' },


        ]
        this.setState({ columns: columns }, () => this.fetchOps())
    }

    fetchOps() {

        Service.get('/api/crm/user/pref/crm_user_favourite_project/?stage=3&is_trashed=False', {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                // let filtered = res.data.filter(ele => ele.bid_resource)
                // let completedOpportunitis = []; let live = [];
                // filtered.forEach(opportunity => {
                //     if (opportunity.archive_reason > 0) {
                //         completedOpportunitis.push(opportunity);
                //     }
                //     else live.push(opportunity)
                // })
                let resDataLive = getDataIsdeletedFalse(res.data.live);
                let resDataCompleted = getDataIsdeletedFalse(res.data.completed);
                this.setState({ data: resDataLive, completedOpportunities: resDataCompleted, }, () => {
                    let searchParams = new URLSearchParams(window.location.search)
                    // let searchParams;
                    let project;
                    // let lastUri = sessionStorage.getItem('lasturi');
                    // if (lastUri) {
                    //     searchParams = new URLSearchParams(lastUri.split("?")[1])
                    project = searchParams.get("proj")
                    // }

                    let allOpportunities = [...this.state.data, ...this.state.completedOpportunities]
                    // let params = new URLSearchParams(window.location.href.split("?")[1])
                    // let comp = parseInt(params.get("proj"))
                    if (project) {
                        let selectedOpportuniti = allOpportunities.filter((opportunity) => opportunity.id === parseInt(project))
                        if (selectedOpportuniti.length > 0) {
                            // let searchParams = new URLSearchParams(window.location.search)

                            // searchParams.set("proj", parseInt(project));

                            // let hash = window.location.hash

                            // let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

                            // window.history.pushState(null, '', newRelativePathQuery);
                            // sessionStorage.setItem("lasturi", `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Secured&proj=${parseInt(comp)}`)
                            // window.history.pushState({ id: window.location.href }, '', `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Secured&proj=${parseInt(comp)}`)
                            this.setState({ selectedOpportunity: selectedOpportuniti[0], modelOpen: true })
                        } else {
                            // let searchParams = new URLSearchParams(window.location.search)

                            // searchParams.delete("proj");

                            // let hash = window.location.hash

                            // let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

                            // window.history.pushState(null, '', newRelativePathQuery);
                            // sessionStorage.setItem("lasturi", `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Secured`)
                            // window.history.pushState({ id: window.location.href }, '', `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Secured`)
                        }
                    } else {
                        // let searchParams = new URLSearchParams(window.location.search)

                        searchParams.delete("proj");

                        let hash = window.location.hash

                        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

                        window.history.pushState(null, '', newRelativePathQuery);
                        // sessionStorage.setItem("lasturi", `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Secured`)
                        // window.history.pushState({ id: window.location.href }, '', `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Secured`)
                    }
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
            .finally(e => {
                setTimeout(() => {
                    this.setState({ isLoading: false })
                }, 1000);
            })
    }

    rowClicked = (e, rowdata) => {

        // sessionStorage.setItem("lasturi", `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Unsecured&proj=${rowdata.id}`)
        // window.history.pushState({ id: window.location.href }, '', `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Unsecured&proj=${rowdata.id}`)

        let searchParams = new URLSearchParams(window.location.search)

        searchParams.set("proj", rowdata.id);

        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);


        this.setState({ selectedOpportunity: rowdata })
        this.handleClickOpen()
    }

    handleClickOpen = () => { this.setState({ modelOpen: true }) }


    handleClose = () => {
        // sessionStorage.setItem("lasturi", `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Unsecured`)
        // window.history.pushState({ id: window.location.href }, '', `${window.location.protocol}//${window.location.host}/#Dashboard?comp=Unsecured`)
        let searchParams = new URLSearchParams(window.location.search)

        searchParams.delete("proj");

        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;


        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ modelOpen: false })
    }


    handleViewType(e) {
        this.setState({ view_type: e.target.value })
    }

    refreshData(responseData, rowData) {
        let dataToChange = this.state.data
        for (let index = 0; index < dataToChange.length; index++) {
            const element = dataToChange[index];
            if (element.id === rowData.id) {
                element.is_favourite = responseData.is_favourite
                break
            }
        }


        dataToChange.sort(function (a, b) { return b.is_favourite - a.is_favourite })
        this.setState({
            data: dataToChange,
            isLoading: true
        }, () => {
            this.setState({
                isLoading: false
            })
        })
    }

    favourite(rowData) {
        if ('crm_user_pref_id' in rowData) {
            let obj = {
                "is_favourite": !rowData.is_favourite,
            }
            Service.patch(`/api/crm/user/pref/${rowData.crm_user_pref_id}/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: obj,
            })
                .then(res => {
                    this.refreshData(res.data, rowData)

                })
                .catch(error => {
                    this.setState({ isLoading: false })
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                })
        } else {
            let obj = {
                "crm": rowData.id,
                "ptd_employee": user.id,
                "is_favourite": !rowData.is_favourite,
                "created_by": user.id
            }
            Service.post(`/api/crm/user/pref/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: obj,
            })
                .then(res => {
                    this.refreshData(res.data, rowData)

                })
                .catch(error => {
                    this.setState({ isLoading: false })
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                })

        }
    }

    changeView(value) {
        this.setState({
            tabValue: value
        })
    }



    render() {
        const access = this.props.access.access
        return (<>
            {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> : <div>
                <Paper square>
                    <TabPanel value={this.state.tabValue} index={0}>
                        <MaterialTable
                            title={<h2>Unsecured Opportunity</h2>}
                            columns={this.state.columns}
                            data={this.state.data}
                            isLoading={this.state.isLoading}
                            options={{
                                paging: false,
                                pageSize: 20,
                                pageSizeOptions: [10, 20, 50, 100],
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                filtering: true,
                                padding: 'dense'
                            }}
                            onRowClick={(e, rowData) => { this.rowClicked(e, rowData) }}
                            actions={[
                                rowData => ({
                                    icon: () => rowData.is_favourite ? <StarIcon color="secondary" /> : <StarBorderIcon color="secondary" />,
                                    tooltip: rowData.is_favourite ? "Select to Remove Favourite" : "Select to Add Favourite",
                                    onClick: (event, rowData) => this.favourite(rowData)
                                })
                            ]}
                        /> </TabPanel>

                    <TabPanel value={this.state.tabValue} index={1}>
                        <MaterialTable
                            title={<h2>Completed</h2>}
                            columns={this.state.columns}
                            data={this.state.completedOpportunities}
                            isLoading={this.state.isLoading}
                            options={{
                                paging: false,
                                pageSize: 20,
                                pageSizeOptions: [10, 20, 50, 100],
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                filtering: true,
                                padding: 'dense'
                            }}
                            onRowClick={(e, rowData) => { this.rowClicked(e, rowData) }}
                            actions={[
                                rowData => ({
                                    icon: () => rowData.is_favourite ? <StarIcon color="secondary" /> : <StarBorderIcon color="secondary" />,
                                    tooltip: rowData.is_favourite ? "Select to Remove Favourite" : "Select to Add Favourite",
                                    onClick: (event, rowData) => this.favourite(rowData)
                                })
                            ]}
                        /> </TabPanel></Paper>

                <div>
                    <Dialog fullScreen open={this.state.modelOpen} onClose={this.handleClose} TransitionComponent={Transition}>
                        <AppBar className={this.props.classes.appBar}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={this.props.classes.title}>
                                    {this.state.selectedOpportunity.name}
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <div style={{ padding: '15px' }} className={this.props.classes.formContainer}>
                            <PRPTemplate
                                project={this.state.selectedOpportunity}
                                isLoading={this.props.isLoading}
                                closeModal={this.handleClose} a
                                addPRPAccess={access.l5a && access.l5a.l5a_b}
                                editPRPAccess={access.l5a && access.l5a.l5a_c}
                                uploadPRPAccess={access.l5a && access.l5a.l5a_c}
                                deletePRPAccess={access.l5a}
                            />
                        </div>
                    </Dialog>
                </div>
            </div>
            }
        </>)
    }
}

export default withSnackbar(withStyles(useStyles)(UnsecuredProjects))